import { createSelector } from 'reselect';

export const selectUsersSlice = state => state.users;

export const selectUsers = createSelector(
  selectUsersSlice,
  slice => slice.users
);
export const selectActiveUser = createSelector(
  selectUsersSlice,
  slice => slice.activeUser
);
export const selectActiveUserPermissions = createSelector(
  selectUsersSlice,
  slice => slice.activeUserPermissions
);

export const userCreating = createSelector(
  selectUsersSlice,
  slice => slice.isCreating
);
export const userUpdating = createSelector(
  selectUsersSlice,
  slice => slice.isUpdating
);
export const userDeleting = createSelector(
  selectUsersSlice,
  slice => slice.isDeleting
);
export const userErrors = createSelector(
  selectUsersSlice,
  slice => slice.errors
);

export const usersFilters = createSelector(
  selectUsersSlice,
  slice => slice.filters
);
export const usersMeta = createSelector(
  selectUsersSlice,
  slice => slice.meta
);
